import { VOCategory, VOHome } from "../model/DataStructure.js";
import { Resource } from "../model/Resource.js";

export class Logo {
    public onRequestCategory = e5.Signal.create<[VOCategory]>();

    public element: HTMLDivElement;

    constructor(home: VOHome) {
        this.element = document.createElement("div");
        this.element.id = "logo";
        this.element.className = "active";
        this.element.innerHTML = `
        <img id="logo-image" src="${Resource.asset("logo.svg")}"></img>
        <div id="about-awi"></div>
        <div id="about-mosaic"></div>`;

        if (home.about_awi)
            this.element.querySelector("#about-awi").addEventListener("click", () => this.onRequestCategory.dispatch(home.about_awi));
        if (home.about_mosaic)
            this.element.querySelector("#about-mosaic").addEventListener("click", () => this.onRequestCategory.dispatch(home.about_mosaic));
    }

    public get active(): boolean {
        return this.element.classList.contains("active");
    }

    public set active(active: boolean) {
        this.element.classList.toggle("active", active);
    }
}